import { IconProps } from "~/design-system/types";

export function InstagramIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79412 0C6.6226 0 6.34949 0 5.49687 0.0467251C4.65091 0.0867751 4.06473 0.220275 3.56514 0.420526C3.03226 0.620776 2.5793 0.901126 2.133 1.335C1.70669 1.80225 1.43359 2.2428 1.22709 2.77013C1.02726 3.27743 0.894037 3.86483 0.85407 4.70588C0.800781 5.57363 0.800781 5.84063 0.800781 8.01001C0.800781 10.1794 0.800781 10.4597 0.847409 11.3141C0.887376 12.1619 1.0206 12.7493 1.22043 13.2499C1.42027 13.7839 1.70003 14.2311 2.13967 14.6783C2.60594 15.0922 3.0589 15.3659 3.58513 15.5728C4.09137 15.7731 4.67755 15.9066 5.51685 15.9466C6.3828 15.9933 6.64924 16 8.82077 16C10.9923 16 11.2721 16 12.1247 15.9466C12.964 15.9066 13.5502 15.7731 14.0564 15.5728C14.5893 15.3726 15.0289 15.0922 15.4752 14.6516C15.9082 14.1977 16.1813 13.7505 16.3878 13.2232C16.5876 12.7159 16.7208 12.1285 16.7542 11.2874C16.7941 10.4197 16.8008 10.1527 16.8008 7.97664C16.8008 5.80058 16.8008 5.52691 16.7542 4.67251C16.7142 3.83813 16.581 3.25073 16.3811 2.73675C16.1813 2.20275 15.8882 1.76888 15.4486 1.32165C14.989 0.867751 14.556 0.600751 14.0298 0.400501C13.5235 0.20025 12.9373 0.0667501 12.098 0.020025C11.2388 0 10.9723 0 8.79412 0ZM8.79477 1.44141C10.9263 1.44141 11.1795 1.44141 12.0254 1.48813C12.8048 1.52818 13.2244 1.65501 13.5108 1.76848C13.8839 1.90198 14.1503 2.08221 14.4301 2.36923C14.7098 2.63623 14.883 2.90323 15.0296 3.28371C15.1362 3.57073 15.2627 3.99126 15.296 4.77224C15.3426 5.61996 15.3493 5.87361 15.3493 8.00962C15.3493 10.1456 15.3493 10.3993 15.3027 11.247C15.2627 12.028 15.1362 12.4485 15.0229 12.7355C14.8897 13.1093 14.7098 13.3763 14.4234 13.6567C14.157 13.937 13.8905 14.1106 13.5108 14.2574C13.2244 14.3642 12.8048 14.4911 12.0254 14.5244C11.1795 14.5712 10.9263 14.5778 8.79477 14.5778C6.66322 14.5778 6.41009 14.5778 5.56413 14.5311C4.78478 14.4911 4.36513 14.3642 4.0787 14.2508C3.70568 14.1173 3.43924 13.937 3.15947 13.65C2.8797 13.383 2.70651 13.116 2.55997 12.7355C2.45339 12.4485 2.32683 12.028 2.29352 11.247C2.2469 10.3993 2.24023 10.1456 2.24023 8.00962C2.24023 5.87361 2.24023 5.61996 2.28686 4.77224C2.32683 3.99126 2.45339 3.57073 2.56663 3.28371C2.69985 2.90991 2.8797 2.64291 3.16613 2.36256C3.43257 2.08221 3.69902 1.90866 4.0787 1.76181C4.36513 1.65501 4.78478 1.52818 5.56413 1.49481C6.41009 1.44808 6.66322 1.44141 8.79477 1.44141ZM4.69141 8.01024C4.69141 5.74074 6.52987 3.89844 8.79465 3.89844C11.0594 3.89844 12.8979 5.74074 12.8979 8.01024C12.8979 10.2797 11.0594 12.1221 8.79465 12.1221C6.52987 12.1221 4.69141 10.2797 4.69141 8.01024ZM8.79335 10.6799C7.32791 10.6799 6.12891 9.47835 6.12891 8.00985C6.12891 6.54135 7.32791 5.33984 8.79335 5.33984C10.2588 5.33984 11.4578 6.54135 11.4578 8.00985C11.4578 9.47835 10.2588 10.6799 8.79335 10.6799ZM13.0634 4.69227C13.5896 4.69227 14.0226 4.27174 14.0226 3.73774L14.0559 3.70437C14.0559 3.17704 13.6229 2.74316 13.0901 2.74316C12.5572 2.74316 12.1309 3.19706 12.1309 3.73107C12.1309 4.26507 12.5305 4.69227 13.0634 4.69227Z"
        fill={color}
      />
    </svg>
  );
}

export function FacebookIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14442 5.33301V3.2C2.14442 3.19313 2.1444 3.18553 2.14438 3.17723C2.14313 2.70855 2.13591 0 5.43071 0H7.80156V3.2H5.74442C5.60355 3.18262 5.46277 3.2332 5.36246 3.33723C5.26215 3.44126 5.21338 3.58725 5.23013 3.73333V5.33301H7.80156L7.28728 8.53301H5.23013V16H2.14442V8.53301H0.601562V5.33301H2.14442Z"
        fill={color}
      />
    </svg>
  );
}

export function YoutubeIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.85145 10.1624V4.42459L12.8202 7.29365L7.85145 10.1624ZM18.9272 2.69C18.7072 1.86726 18.0592 1.21911 17.2363 0.999173C15.7448 0.599609 9.76395 0.599609 9.76395 0.599609C9.76395 0.599609 3.78324 0.599609 2.29172 0.999173C1.46882 1.21911 0.820827 1.86726 0.600893 2.69C0.201172 4.18167 0.201172 7.29349 0.201172 7.29349C0.201172 7.29349 0.201172 10.4055 0.600893 11.897C0.820827 12.7197 1.46882 13.368 2.29172 13.5878C3.78324 13.9875 9.76395 13.9875 9.76395 13.9875C9.76395 13.9875 15.7448 13.9875 17.2363 13.5878C18.0592 13.368 18.7072 12.7197 18.9272 11.897C19.3269 10.4055 19.3269 7.29349 19.3269 7.29349C19.3269 7.29349 19.3269 4.18167 18.9272 2.69Z"
        fill={color}
      />
    </svg>
  );
}

export function TwitterIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
  );
}

export function LinkedinIcon({ color = "#ffffff", ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.959 11.7189V19.0979H15.681V12.2129C15.681 10.4829 15.062 9.30288 13.514 9.30288C12.332 9.30288 11.628 10.0989 11.319 10.8679C11.206 11.1429 11.177 11.5259 11.177 11.9109V19.0979H6.897C6.897 19.0979 6.955 7.43788 6.897 6.22888H11.177V8.05288L11.149 8.09488H11.177V8.05288C11.745 7.17788 12.76 5.92688 15.033 5.92688C17.848 5.92688 19.959 7.76688 19.959 11.7189ZM2.421 0.0258789C0.958 0.0258789 0 0.985879 0 2.24888C0 3.48388 0.93 4.47288 2.365 4.47288H2.393C3.886 4.47288 4.813 3.48388 4.813 2.24888C4.787 0.985879 3.887 0.0258789 2.422 0.0258789H2.421ZM0.254 19.0979H4.532V6.22888H0.254V19.0979Z"
        fill={color}
      />
    </svg>
  );
}

export const socialIcons = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  linkedin: LinkedinIcon,
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
};
